export default {
    name: 'ContextGeoLocation',
    properties: {
        lat: { required: true },
        lon: { required: true },
    },
};
